export enum Channel {
  RenderbusWeb = 2,
  FoxWeb = 3,
}
